/**
 * True while Next.js is prerendering during `next build` (`NEXT_PHASE=phase-production-build`).
 *
 * Evaluated once at module load, so it reflects the process it runs in: `true` in the build
 * process, `false` in the serverless/edge runtime (separate processes, each loads the module
 * fresh). Reading it as a captured constant — rather than touching `process.env` inside an
 * `unstable_cache` callback — keeps cached functions clean.
 *
 * Use it to decide whether an upstream fetch should swallow a failure or throw:
 * - **Build:** swallow to a fallback so a transient backend blip can't fail the deploy (ISR
 *   replaces the fallback on the first successful revalidation).
 * - **Runtime:** throw, so a failed ISR revalidation keeps serving the last good cached render
 *   (stale-while-error) instead of caching a blank page.
 */
export const isBuildPhase = process.env.NEXT_PHASE === 'phase-production-build';
